import { action } from 'typesafe-actions';
import { Actions, TDefRequest } from '../Action';
import ActionTypes, { TDataToEvents, TLikeMessage, TMessage, TSendMessage, TShowEvent, TSocketState } from './types';

export const SocketActions = {
  setRoom: (payload: TSocketState['room']) => action(ActionTypes.SET_ROOM, payload),
  setChat: (payload: TSocketState['chat']) => action(ActionTypes.SET_CHAT, payload),
  setSocketError: (payload: TSocketState['errors']) => action(ActionTypes.ERROR, payload),
  setNewMessage: (payload: TMessage) => action(ActionTypes.SET_NEW_MESSAGE, payload),
  setUpdateMessage: (payload: TSocketState['likedMessage']) => action(ActionTypes.SET_UPDATE_MESSAGE, payload),
  setDeleteMessage: (payload: TSocketState['likedMessage']) => action(ActionTypes.SET_DELETE_MESSAGE, payload),
  setCallActionId: (payload: number) => action(ActionTypes.SET_CALL_ACTION_ID_ROOM, payload),
};

const ShowEventsAction = new Actions('SHOW_EVENT', ActionTypes);
export interface TypeShowEventsR extends TDefRequest {
  data: TDataToEvents;
}
export const ShowEvent = {
  request: (payload: TypeShowEventsR) => ShowEventsAction.request(payload),
  success: (payload: TShowEvent) => ShowEventsAction.success(payload || {}),
  error: (message: string) => ShowEventsAction.error(message),
};

const SendMessageAction = new Actions('SEND_MESSAGE', ActionTypes);
export interface TypeSendMessageR extends TDefRequest {
  data: TSendMessage;
}
export const SendMessage = {
  request: (payload: TypeSendMessageR) => SendMessageAction.request(payload),
  success: (payload: TMessage) => SendMessageAction.success(payload || {}),
  error: (message: string) => SendMessageAction.error(message),
};

const LikeMessageAction = new Actions('LIKE_MESSAGE', ActionTypes);
export interface TypeLikeMessageR extends TDefRequest {
  data: TLikeMessage;
}
export const LikeMessage = {
  request: (payload: TypeLikeMessageR) => LikeMessageAction.request(payload),
  success: (payload: TMessage) => LikeMessageAction.success(payload || {}),
  error: (message: string) => LikeMessageAction.error(message),
};

const MetricsUkdAction = new Actions('METRICS_UKD', ActionTypes);
export interface TypeMetricsUkdR extends TDefRequest {
  data: {
    event_id: number;
  };
}
export const MetricsUkd = {
  request: (payload: TypeMetricsUkdR) => MetricsUkdAction.request(payload),
  success: (payload: string) => MetricsUkdAction.success(payload || {}),
  error: (message: string) => MetricsUkdAction.error(message),
};

const GetWebinarCertificateAction = new Actions('GET_WEBINAR_CERTIFICATE', ActionTypes);
export interface TypeGetWebinarCertificateR extends TDefRequest {
  data: {
    event_id: number;
  };
}
export const GetWebinarCertificate = {
  request: (payload: TypeGetWebinarCertificateR) => GetWebinarCertificateAction.request(payload),
  success: (payload: Buffer) => GetWebinarCertificateAction.success(payload || {}),
  error: (message: string) => GetWebinarCertificateAction.error(message),
};

const GetMessagesAction = new Actions('GET_MESSAGES', ActionTypes);
export interface TypeGetMessagesR extends TDefRequest {
  data: {
    event_id: number;
    roomId: number;
    page: number;
  };
}
export const GetMessages = {
  request: (payload: TypeGetMessagesR) => GetMessagesAction.request(payload),
  success: (payload: TSocketState['chat']) => GetMessagesAction.success(payload || {}),
  error: (message: string) => GetMessagesAction.error(message),
};
